import React from 'react';

function NotFound(props) {
    return (
        <div className='container-fluid text-center' style={{fontSize:'50px',marginTop:'50px'}}>
            Error  <br/> 
             Not Found
        </div>
    );
}

export default NotFound;